module.exports = __webpack_public_path__ + "static/media/frame3.31d63bb8.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/frame-bottom/frame3.png
// module id = 76
// module chunks = 0